import React from "react";

const CommitmentsGrid = props => {
  const {data, remove, edit, findings, preview, responsible} = props;

  const handleFinding = idFinding => {
    const id = Number(idFinding);
    const finding = findings.find(f => f.HallazgoId === id);
    return finding?.Observacion || "";
  };

  const handleUser = id => {
    const user = responsible.find(u => u.value === Number(id));
    return user?.label;
  };

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Hallazgo</th>
            <th scope="col">Compromiso</th>
            <th scope="col">Responsable</th>
            <th scope="col">Email EE.SS</th>
            <th scope="col">Requiere</th>
            <th scope="col">
              <div className="text-nowrap">Fecha control</div>
            </th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.idCompromiso}>
              <th scope="row">{item.idCompromiso}</th>
              <td style={{maxWidth: 300}}>
                <div className="text-nowrap text-truncate">
                  {handleFinding(item.HallazgoId)}
                </div>
              </td>
              <td style={{maxWidth: 300}}>
                <div className="text-nowrap text-truncate">
                  {item.Compromiso}
                </div>
              </td>
              <td>{handleUser(item.Responsable)}</td>
              <td>{item.eess}</td>
              <td>{item.Requiere ? "Si" : "No"}</td>
              <td>{item.FechaControl}</td>
              <td>
                <div className="d-flex">
                  <button
                    type="button"
                    className="ms-2 btn bg-primary btn-sm text-white"
                    onClick={() => preview(item)}
                  >
                    Ver
                  </button>
                  {edit && (
                    <button
                      type="button"
                      className="ms-2 btn bg-primary btn-sm text-white"
                      onClick={() => edit(item)}
                    >
                      Editar
                    </button>
                  )}
                  {remove && (
                    <button
                      type="button"
                      className="ms-2 btn btn-danger btn-sm"
                      onClick={() => remove(item.idCompromiso)}
                    >
                      Eliminar
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CommitmentsGrid;
